import React from 'react';
export function Footer() {
  return <footer className="mt-12 py-6 border-t border-gray-200 text-center text-[#052858]" data-id="element-11">
      <div className="max-w-3xl mx-auto px-4" data-id="element-12">
        <a href="https://www.krnwtr.nl" target="_blank" rel="noopener noreferrer" className="text-[#052858] hover:text-[#19EAC4] transition-colors" data-id="element-13">
          www.krnwtr.nl
        </a>
        <div className="my-3" data-id="element-14">
          <span className="inline-block" data-id="element-15">📞 020 808 84 00</span>
        </div>
      </div>
    </footer>;
}